const state = () => ({
  isSubmissionReview: false,
  contextScope: null,
  sectionId: null
})

const getters = {
  getIsSubmissionReview: (state) => state.isSubmissionReview,
  getContextScope: (state) => state.contextScope,
  getSectionId: (state) => state.sectionId
}

const mutations = {
  setIsSubmissionReview(state, value) {
    state.isSubmissionReview = value;
  },
  setContextScope(state, scope) {
    state.contextScope = scope;
  },
  setSectionId(state, id) {
    state.sectionId = id;
  },
  clearLtiState(state) {
    state.isSubmissionReview = false;
    state.contextScope = null;
    state.sectionId = null;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
